import { SecurityTransaction } from "./security-transaction";
import {
  AsicShareholderValidationError,
  CorporateHolderModel,
  IndividualHolderModel,
  SecurityRegistryRecord
} from "../shares/security-registry-record";
import {
  SecurityHoldingValidationError,
  SecurityHoldingValidationErrorMinusCurrentBalance,
  SecurityHoldingValidationErrorMinusHistoricalBalance
} from "../shares/security-holding-validation-error";

export class ClientSecurityTransaction extends SecurityTransaction {
  record: SecurityRegistryRecord;

  holders: (IndividualHolderModel | CorporateHolderModel)[];
  numberBalance: number;
  paidBalance: number;
  unpaidBalance: number;
  isBeneficialOwnerLabel: string;
  beneficialOwnerNames: string;
  validationError: AsicShareholderValidationError | null;
  holdingValidationErrors: SecurityHoldingValidationError[];
  nonAsic: boolean;

  groupNumberBalance: number;
  groupPaidBalance: number;
  groupUnpaidBalance: number;

  // group by options
  hash: string;
  hashWithType: string;
  hashWithClass: string;

  constructor(data: Partial<ClientSecurityTransaction> = {}) {
    super(data);

    this.record = data.record!;

    this.holders = data.holders ?? [];
    this.numberBalance = data.numberBalance ?? 0;
    this.paidBalance = data.paidBalance ?? 0;
    this.unpaidBalance = data.unpaidBalance ?? 0;
    this.isBeneficialOwnerLabel = data.isBeneficialOwnerLabel ?? 'No';
    this.beneficialOwnerNames = data.beneficialOwnerNames ?? '';
    this.validationError = data.validationError ?? null;
    this.holdingValidationErrors = data.holdingValidationErrors ?? this.record?.holdings?.find((holding) => holding.securityHoldingId == this.securityHoldingId)?.validationErrors ?? [];
    this.nonAsic = data.nonAsic ?? true;

    this.groupNumberBalance = data.groupNumberBalance ?? 0;
    this.groupPaidBalance = data.groupPaidBalance ?? 0;
    this.groupUnpaidBalance = data.groupUnpaidBalance ?? 0;

    this.hash = data.hash ?? '';
    this.hashWithType = data.hashWithType ?? '';
    this.hashWithClass = data.hashWithClass ?? '';
  }

  get name(): string {
    return this.holders.map((holder) => holder.name).join(', ') + ` (${ this.numberBalance } ${ this.securityType.class })`;
  }

  get isIncludeAlert(): boolean {
    // show alert if
    // - transaction include holding error of type SecurityHoldingValidationErrorMinusCurrentBalance

    return !!this.holdingValidationErrors.find((validationError) => validationError.$type == SecurityHoldingValidationErrorMinusCurrentBalance.$type);
  }

  get isIncludeWarning(): boolean {
    // show warning if
    // - transaction include holding error of type SecurityHoldingValidationErrorMinusHistoricalBalance
    // - AND the error include transactionId of the transaction

    const relatedHoldingValidationError = this.holdingValidationErrors.find((validationError) => validationError.$type == SecurityHoldingValidationErrorMinusHistoricalBalance.$type);
    const transactionId = this.securityTransactionId;
    return Boolean(relatedHoldingValidationError && transactionId && (relatedHoldingValidationError as SecurityHoldingValidationErrorMinusHistoricalBalance | undefined)?.transactionIds.includes(transactionId));
  }
}
